import { render } from "./Help.vue?vue&type=template&id=6c125efa&ts=true"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__